// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {getAuth} from 'firebase/auth';
import {getFirestore} from 'firebase/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCpyo_KlbwvrVL-UA6d60TgdwvZ-3LCqI0",
  authDomain: "nand-cash-and-carry-ltd.firebaseapp.com",
  projectId: "nand-cash-and-carry-ltd",
  storageBucket: "nand-cash-and-carry-ltd.firebasestorage.app",
  messagingSenderId: "363216350287",
  appId: "1:363216350287:web:88f6890df51982c7bc0e3a",
  measurementId: "G-EWH3F8D0SJ"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);

export {app, auth, analytics, db};